import type { MappedServiceObjectData } from 'common/models';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectSectionItem from './ServiceObjectSectionItem';
import ServiceObjectSubSection from './ServiceObjectSubSection';

interface OwnProps {
  serviceObjects: ServiceObjectInCustomer[];
  data: MappedServiceObjectData[];
  columns?: number;
  width?: string;
  title?: string;
}

const ServiceObjectSections = (props: OwnProps) => {
  const { data, serviceObjects, width, columns, title } = props;

  const columnsWidthArray = width ? width.split('/') : undefined;

  return (
    <div className="ReportSection ServiceObjectSection">
      {title && <div className="SectionTitle">{title}</div>}
      {serviceObjects.map((serviceObject) => {
        return (
          <div key={serviceObject.id} className="ServiceObject">
            <div className="name">{serviceObject.name}</div>
            <div className={`SectionContent ${!columnsWidthArray ? `cols-${columns || 1}` : ''}`}>
              {data.map((reportData, i) => {
                if (reportData.type === 'Section') {
                  return (
                    <ServiceObjectSubSection
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      reportData={reportData}
                      serviceObject={serviceObject}
                      columnsWidthArray={columnsWidthArray}
                    />
                  );
                }

                return (
                  <ServiceObjectSectionItem
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    index={i}
                    reportData={reportData}
                    serviceObject={serviceObject}
                    columnsWidthArray={columnsWidthArray}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ServiceObjectSections;
